import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-videoguide',
  templateUrl: './videoguide.component.html',
  styleUrls: ['./videoguide.component.css']
})
export class VideoguideComponent implements OnInit {
  
  userguide: any = '/assets/help/MOM_PhaseII_Video_Guide/MOM_UserManual.pdf';
  videoPath: any = '/assets/help/MOM_PhaseII_Video_Guide/MOM_LOGIN.mp4';
  videoTitle: any ="Log in";
  videoDesc: any ="Login functionality";
  @ViewChild('helpVideoPlayer', { static: false } as any) HelpVideoPlayer: ElementRef;
    userRole: number;
  constructor(private userService: UserService,) { }

  ngOnInit(): void {

    var user = this.userService.getUserInfo();

    if(user==undefined){
      this.userService.logout();
    }
    else{
      this.userRole = Number(user.role);
    } 
    
  }

  videoChange(path:any) {
    ;
    this.videoPath = '';
    if (path == 'login') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/MOM_LOGIN.mp4';
      this.videoTitle = "Login Title";
      this.videoDesc = "Login Description";
    }
    else if (path == 'profile') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/Profile.mp4';
      this.videoTitle = "Profile Title";
      this.videoDesc = "Profile Description";
    }
    else if (path == 'dash') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/Dashboard.mp4';
      this.videoTitle = "Dashboard Title";
      this.videoDesc = "Dashboard Description";
    }
    else if (path == 'createMOM') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/Create MOM.mp4';
      this.videoTitle = "Create MOM Title";
      this.videoDesc = "Create MOM Description";
    }
    else if (path == 'copyFollow') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/Copy and Follow up.mp4';
      this.videoTitle = "Copy and Follow up Title";
      this.videoDesc = "Copy and Follow up Description";
    }
    else if (path == 'approval') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/Approval Process.mp4';
      this.videoTitle = "Approval Process Title";
      this.videoDesc = "Approval Process Description";
    }
    else if (path == 'review') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/Review.mp4';
      this.videoTitle = "Review Process Title";
      this.videoDesc = "Review Process Description";
    }
    
    else if (path == 'publish') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/Publish and download.mp4';
      this.videoTitle = "Publish and Download Process Title";
      this.videoDesc = "Publish and Download Description";
    }
    else if (path == 'attendance') {
      this.videoPath = '/assets/help/MOM_PhaseII_Video_Guide/Digital Attendance.mp4';
      this.videoTitle = "Digital Attendance Process Title";
      this.videoDesc = "Digital Attendance Description";
    }
    
  }
}
